'use client';

import React, { type FC } from 'react';
import { tabsTriggerVariants } from '@paypoteam/page-components';
import { Button } from '@paypoteam/ui-components';
import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';

import { cn } from '@/lib/utils';

import type { CategoryButtonsProps } from '../SectionShopSearch.types';
import { categoryPath, getCategory } from '../utils/getCategory';

const CategoryButtonsSlider: FC<CategoryButtonsProps> = ({
    categoryData,
    customButton,
    showFilterNew = false,
    ...props
}) => {
    const { title: buttonTitle, isActive, handleClick } = customButton;

    const category = getCategory();

    return (
        <div {...props}>
            <Swiper
                spaceBetween={16}
                slidesPerView="auto"
                onSwiper={swiper =>
                    setTimeout(() => {
                        swiper.update();
                    }, 1000)
                }
                navigation
            >
                {showFilterNew && (
                    <SwiperSlide className="slide !w-fit py-1 pl-1">
                        <Button
                            onClick={e => {
                                e.preventDefault();

                                Sentry.addBreadcrumb({
                                    category: 'shop search',
                                    message:
                                        'click to category button' +
                                        buttonTitle,
                                    level: 'info',
                                });

                                handleClick();
                            }}
                            aria-expanded="false"
                            data-state={isActive ? 'active' : 'inactive'}
                            className={cn(
                                tabsTriggerVariants({
                                    variant: 'secondary',
                                    size: 'm',
                                }),
                            )}
                        >
                            {buttonTitle}
                        </Button>
                    </SwiperSlide>
                )}

                {categoryData.length &&
                    categoryData.map(({ slug, title: categoryName, type }) => {
                        const subcategoryName = slug.split('/').shift();

                        return (
                            <SwiperSlide
                                key={slug}
                                className={cn(
                                    'slide !flex !w-fit py-1',
                                    !showFilterNew && 'first:pl-1',
                                )}
                            >
                                <Link
                                    href={`/p/${categoryPath}/${
                                        type === 'subcategory'
                                            ? `${category}/${subcategoryName}`
                                            : slug
                                    }`}
                                    className={cn(
                                        tabsTriggerVariants({
                                            variant: 'secondary',
                                            size: 'm',
                                        }),
                                    )}
                                >
                                    {categoryName}
                                </Link>
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
        </div>
    );
};

export default CategoryButtonsSlider;
